import { Anchor, Divider, Group, Modal, Stack, Text } from "@mantine/core";
import {
  IconBrandTelegram,
  IconBrandWhatsapp,
  IconPhone,
} from "@tabler/icons-react";
import Rules from ".";
import { useDisclosure } from "@mantine/hooks";

export default function RulesConfirmation() {
  const [opened, { close, open }] = useDisclosure(false);
  return (
    <>
      <Stack justify="center" align="center" gap="5">
        <Text size="xs" c="dimmed">
          با ورود به پدیکس،{" "}
          <Anchor onClick={open} underline="always">
            قوانین و مقررات
          </Anchor>{" "}
          سایت را پذیرفته ام.
        </Text>
        <Divider />
        <Group gap="xs" justify="center">
          <Anchor href="https://wa.me/+989991047041" target="_blank">
            <IconBrandWhatsapp color="gray" stroke={1} size={20} />
          </Anchor>
          <Anchor href="https://t.me/padix_support" target="_blank">
            <IconBrandTelegram color="gray" stroke={1} size={20} />
          </Anchor>
          {/* <IconBrandInstagram color="gray" stroke={1} size={20} /> */}
          <Anchor href="tel:+989991047041">
            <IconPhone color="gray" stroke={1} size={20} />
          </Anchor>
        </Group>
      </Stack>
      <Modal opened={opened} onClose={close} title="قوانین و مقررات" size="lg">
        <Rules />
      </Modal>
    </>
  );
}
